import {OFFLINE_STORES,getOfflineStorageDriver} from './offlineStorageAdapter.js';
import {validateOfflineAttachmentCommand,verifyOfflineAttachmentReceipt} from './offlineAttachmentCommand.js';

const copy=value=>JSON.parse(JSON.stringify(value));
const fail=()=>{throw Error('No se pudo conservar el enlace del archivo confirmado. Se conservan su recibo, bytes e intención.');};

export async function acknowledgedAttachment(file) {
    if(file?.state!=='acknowledged'||!['image','document'].includes(file.kind))fail();
    const manifest=await validateOfflineAttachmentCommand(file,file.uploadCommand);
    const {data}=await verifyOfflineAttachmentReceipt(file,file.uploadCommand,file.uploadReceipt);
    if(file.empresaId!=null&&file.empresaId!==data.empresa_id)fail();
    const common={client_uuid:file.id,file_sha256:file.sha256,size:file.size,descripcion:manifest.descripcion,url:data.url,receiptOnly:true,
        manifest_sha256:file.uploadCommand.manifestSha256,upload_receipt:data,original_name:manifest.filename,
        ...(manifest.acceptance_role?{acceptance_role:manifest.acceptance_role}:{})};
    const item=file.kind==='image'?{...common,filename:data.filename,instance_ref:manifest.instance_ref,instance_label:manifest.instance_label,
        gps_lat:manifest.gps_lat,gps_lng:manifest.gps_lng,gps_accuracy:manifest.gps_accuracy,gps_captured_at:manifest.gps_captured_at}
        :{...common,path:data.filename,nombre:manifest.filename,tipo:manifest.mime_type};
    return{item,manifest};
}

function attach(visit,file,item) {
    const key=file.kind==='image'?'imagenes':'adjuntos_documentacion', path=item.filename||item.path;
    const items=Array.isArray(visit[key])?visit[key]:[];
    const matches=items.filter(value=>value?.client_uuid===file.id||(value?.filename||value?.path)===path);
    if(matches.length>1)fail();
    if(matches.length){const existing=matches[0];
        if(existing.client_uuid!==file.id||(existing.file_sha256&&existing.file_sha256!==file.sha256)
            ||(existing.size!=null&&Number(existing.size)!==file.size)||(existing.filename||existing.path)!==path)fail();
        const enriched={...item,...existing,file_sha256:file.sha256,size:file.size};
        if(!Object.hasOwn(existing,'receiptOnly'))delete enriched.receiptOnly;
        return{...visit,[key]:items.map(value=>value===existing?enriched:value)};
    }
    return{...visit,[key]:[...items,item]};
}

// Se ejecuta antes de retirar MEDIA y también al recuperar un contexto antiguo.
// El recibo verificado es la autoridad; no hace HTTP ni modifica los originales.
export async function projectAcknowledgedAttachment(file,{driver=getOfflineStorageDriver(),verifyBytes,prepareReadCopy,isCurrent=()=>true}={}) {
    if(!isCurrent())fail();
    const {item,manifest}=await acknowledgedAttachment(file),empresaId=manifest.empresa_id;
    if(typeof verifyBytes!=='function')fail();
    await verifyBytes(file);
    const rows=await driver.getAll(OFFLINE_STORES.CONTEXTS,row=>['context','candidate'].includes(row.kind),
        {userId:file.userId,contexts:{visitaId:file.visitaId,empresaId,kinds:['context','candidate']}});
    let owned=rows.filter(row=>row.userId===file.userId&&row.empresaId===empresaId&&row.visitaId===file.visitaId
        &&['context','candidate'].includes(row.kind)&&Number(row.context?.visita?.id)===file.visitaId
        &&Number(row.context?.offline_authorization?.actor?.id)===file.userId
        &&Number(row.context?.offline_authorization?.actor?.empresa_id)===empresaId
        &&Number(row.context?.offline_authorization?.visita_id)===file.visitaId);
    // Una base local restaurada puede reutilizar números de visitas. Conservar
    // la identidad de sucursal conocida; una mezcla ambigua no autoriza enlaces.
    const referenced=owned.filter(row=>[...(row.context.visita.imagenes||[]),...(row.context.visita.adjuntos_documentacion||[])]
        .some(value=>value?.client_uuid===file.id));
    const branches=new Set((referenced.length?referenced:owned).map(row=>Number(row.context.visita.sucursal_id)));
    if(branches.size>1)fail();
    if(referenced.length)owned=owned.filter(row=>branches.has(Number(row.context.visita.sucursal_id)));
    if(owned.length&&manifest.kind==='document'&&manifest.mime_type==='application/pdf'){
        if(typeof prepareReadCopy!=='function')fail();
        await prepareReadCopy(file);
    }
    const updates=[];
    for(const row of owned){const visit=attach(row.context.visita,file,item);
        if(JSON.stringify(visit)===JSON.stringify(row.context.visita))continue;
        updates.push({before:row,value:{...copy(row),version:crypto.randomUUID(),context:{...copy(row.context),visita:visit}}});
    }
    for(const active of updates.filter(update=>update.value.kind==='context')){
        const candidate=owned.find(row=>row.kind==='candidate'&&row.scope===active.value.scope);
        if(!candidate?.baseVersion)continue;
        if(candidate.baseVersion!==active.before.version)fail();
        let update=updates.find(value=>value.before.id===candidate.id);
        if(!update){update={before:candidate,value:{...copy(candidate),version:crypto.randomUUID()}};updates.push(update);}
        update.value.baseVersion=active.value.version;
    }
    if(!isCurrent()||!await driver.commitAttachmentContexts(file,updates,isCurrent))fail();
    return item;
}
